module.exports = __webpack_public_path__ + "static/media/football-carousel-480x320.82b191a4.jpg";